import {LoaderFunctionArgs} from 'react-router-dom';
import {IRoutableModule} from '../../router/routing.infra';
import {getRootStore} from '../../app.bootstrap';
import {RouteName, RouteNameType} from '../../router/route-names';

const loader = async (args: LoaderFunctionArgs): Promise<void> => {
    const url = new URL(args.request.url);
    const code = url.searchParams.get('code');
    const error = url.searchParams.get('error');

    const rootStore = getRootStore();
    const authHandler = rootStore.authHandlerService;
    const nav = rootStore.tsReactStateHelper;

    const result = await authHandler.handleOAuthCallback(code || undefined, error || undefined);

    if (result?.state) {
        await nav.navigateTo(result.state as RouteNameType, result.params);
    }

    await nav.navigateTo(RouteName.LOGIN);
};

export default {
    loader,
    Component: () => null, // No component needed
    storeAs: 'oauthCallbackStore'
} as IRoutableModule;
